import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { ActivatedRoute } from '@angular/router';
import { concatMap, filter, takeWhile } from 'rxjs';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { SpecificationService } from 'src/app/services/shared/product-settings/specification.service';
import { City, Country, State } from 'src/app/models/master-data.model';
import { ProductsService } from 'src/app/services/products.service';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-brand-product-filter',
  templateUrl: './brand-product-filter.component.html',
  styleUrls: ['./brand-product-filter.component.scss']
})
export class BrandProductFilterComponent {
  @Input() data: any[] = [];
  @Input() filterColumns: any;
  @Input() heading!: string;
  @Input() isProducts: boolean = false;
  @Input() type: string = '';
  @Input() id: string = '';
  @Output() filteredData = new EventEmitter<any[]>();
  @Output() newProductss = new EventEmitter<any>();
  @ViewChild('newProductCheckbox') newProductCheckbox!: MatCheckbox;
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;
  @Input() isCatalogSection: boolean = false;
  @Input() catalogData: any[] = [];
  filteredProductCatalogData: any[] = [];

  filteredBrands: any[] | undefined;
  brandControl = new FormControl();

  dataObj: any[] = [];
  dataObj2: any[] = [];
  filteredObj: any[] = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  showNoRecordsFounds: boolean = true;
  filterObject: any;
  countries!: any[];
  states!: any[];
  cities!: any[];
  brands!: any[];
  specialities!: any[];
  products!: any[];
  specifications!: any[];
  shapes!: any[];
  models!: any[];
  sizes!: any[];
  filterSpecifications!: any[];
  sampleTypes!: any[];
  applications!: any[];
  textSpecifications: any;
  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  lightSources!: any[];
  configurations!: any[];
  intensityAt1ms!: any[];
  options!: any[];
  params: any;
  brandId: string = '';
  brandName: string = '';

  filterForm: FormGroup = new FormGroup({
    keywords: new FormControl(null),
    countries: new FormControl(null),
    states: new FormControl(null),
    cities: new FormControl(null),
    zipCode: new FormControl(null),
    brands: new FormControl(null),
    year: new FormControl(null),

  });

  isProductsDropDownOpen: boolean = false;
  productIdsList: any[] = [];
  @Output() productIdsListEmit: any = new EventEmitter<any[]>();

  @Input() brandProfileProducts: any = '';
  @ViewChild('filterMatSelect') filterMatSelect!: MatSelect;
  filteredCatalogInfo: any[] = [];


  filterControls = ['keywords', 'countries', 'states', 'cities', 'zipCode', 'brands'];
  constructor(
    private readonly masterDataService: MasterDataService,
    private oemService: OemService,
    private allProductService: AllProductService,
    private route: ActivatedRoute,
    private specificationService: SpecificationService,
    private productsService: ProductsService,
    private renderer: Renderer2,
  ) {
    window.addEventListener('scroll', this.scrollEvent, true);
    this.params = this.route.snapshot.params;
  }
  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if (autoComplete.panelOpen) {
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if (!isScrollingInsidePanel) {
      this.closeAllPanels();
    }
  }

  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataObj = this.data;
  }
  @ViewChild('searchContainer') searchContainer: ElementRef | undefined;
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const value = params['id'];
      this.brandId = value
    });

    this.loadCountries('');
    this.loadStates('');
    this.loadCities('');
    this.loadBrands();
    this.loadSpecialities();
    this.loadProducts(this.brandId);

    if (this.isCatalogSection) {
      this.filteredProductCatalogData = this.catalogData
      this.filterControls.push('catalogProducts')
      this.filterForm.addControl('catalogProducts', new FormControl([]));
    }

    if (this.type) {

      this.getFilterSpecificationsByType(this.brandId, this.type);
    } else {
      this.getFilterSpecifications(this.brandId);
    }
    this.filterForm.valueChanges.subscribe(() => {
      if (this.isAnyFilterApplied()) {
        // Prevent automatic trigger for number-type specifications
        const specControls = this.filterSpecifications.filter(spec => spec.specificationType === 'Number');
        const numberControlsUpdated = specControls.some(spec =>
          this.filterForm.get(`${spec.specificationName}From`)?.dirty ||
          this.filterForm.get(`${spec.specificationName}To`)?.dirty
        );
        if (!numberControlsUpdated) {
          this.applyFilter();
        }
      } else {
        this.filteredData.emit(this.dataObj);
      }
    });


    this.countryControl.valueChanges.subscribe(value => {
      if (!value?.countryName) {
        this.filteredCountries = this.countries.filter(country =>
          country.countryName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.stateControl.valueChanges.subscribe(value => {
      if (!value?.stateName) {
        this.filteredStates = this.states.filter(state =>
          state.stateName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.cityControl.valueChanges.subscribe(value => {
      if (!value?.cityName) {
        this.filteredCities = this.cities.filter(city =>
          city.cityName.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.brandControl.valueChanges.subscribe(value => {
      if (!value?.name) {
        this.filteredBrands = this.brands.filter(brand =>
          brand.name.toLowerCase().includes(value?.toLowerCase() || '')
        );
      }
    });
    this.renderer.listen('document', 'click', (event: Event) => {
      const searchElement = this.searchContainer?.nativeElement;
      const inputElement = searchElement?.querySelector('input');

      if (searchElement && !searchElement.contains(event.target)) {
        this.isSugestionOpen = false;
      }
      if (inputElement) {
        inputElement.value = ''; // Clear the input field
      }
    });
  }

  isAnyFilterApplied(): boolean {
    const { keywords, countries, states, cities, zipCode, brands } = this.filterForm.value;

    // Check for specification-based filters as well
    const specFiltersApplied = this.filterSpecifications.some((spec: any) => {
      if (spec.specificationType === 'Text') {
        const values = this.filterForm.get(spec.specificationName)?.value;
        return values && values.length > 0;
      } else if (spec.specificationType === 'Number') {
        const fromValue = this.filterForm.get(`${spec.specificationName}From`)?.value;
        const toValue = this.filterForm.get(`${spec.specificationName}To`)?.value;
        return fromValue != null;
      }
      return false;
    });

    return !!keywords || !!countries?.length || !!states?.length || !!cities?.length || !!zipCode || specFiltersApplied;
  }

  onExpansionChange(expanded: boolean, spec: any) {
    if (expanded) {
      const fromControl = this.filterForm?.get(spec.specificationName + 'From');
      if (fromControl && fromControl?.value == null) {
        fromControl?.setValue(spec.numberValues.min);
      }
    }
  }

  onCheckboxChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.newProducts();
    } else {
      this.resetFilters();
    }
  }

  getFilterSpecifications(brandId: string): void {
    this.specificationService.getSpecificationsByCategory(brandId).subscribe(
      (response: any) => {
        this.filterSpecifications = response;
        this.filterSpecifications?.forEach((spec: any) => {
          if (spec.specificationType === 'Text') {
            if (!this.filterControls.includes(spec.specificationName) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(spec.specificationName, new FormControl([]));
              this.filterControls.push(spec.specificationName);
            }
          } else if (spec.specificationType === 'Number') {
            if (!this.filterControls.includes(`${spec.specificationName}From`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}From`, new FormControl());
              this.filterControls.push(`${spec.specificationName}From`);
            }
            if (!this.filterControls.includes(`${spec.specificationName}To`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}To`, new FormControl());
              this.filterControls.push(`${spec.specificationName}To`);
            }
          }
        });

        this.filterSpecifications = Array.from(new Set(this.filterSpecifications.map(s => s.specificationName))).map(specName => {
          const specs = this.filterSpecifications.filter(s => s.specificationName === specName);
          return {
            ...specs[0],
            numberValues: {
              min: Math.min(...specs.map(s => s.numberValues.min)),
              max: Math.max(...specs.map(s => s.numberValues.max)),
            },
          };
        });

      },
      (error) => {
      }
    );
  }

  applyFilter(): void {
    if (this.newProductCheckbox) {
      this.newProductCheckbox.checked = false;
    }
    let filtered = this.dataObj;
    const { keywords, countries, states, cities, zipCode, brands } = this.filterForm.value;
    if (keywords && keywords.length > 0) {
      const lowerCaseKeywords = keywords.map((keyword: string) => keyword.toLowerCase());
      filtered = filtered.filter(item =>
        (item.id && item.id.length > 0 && lowerCaseKeywords.some((keyword: string) => item.id.toLowerCase().includes(keyword))) ||
        (item.name && item.name.length > 0 && lowerCaseKeywords.some((keyword: any) => item.name.toLowerCase().includes(keyword))) ||
        (item.companyName && item.companyName.length > 0 && lowerCaseKeywords.some((keyword: any) => item.companyName.toLowerCase().includes(keyword))) ||
        (item.email && item.email.length > 0 && lowerCaseKeywords.some((keyword: any) => item.email.toLowerCase().includes(keyword))) ||
        (item.address && item.address.length > 0 && lowerCaseKeywords.some((keyword: any) => item.address.toLowerCase().includes(keyword))) ||
        (item.title && item.title.length > 0 && lowerCaseKeywords.some((keyword: any) => item.title.toLowerCase().includes(keyword))) ||
        (item.oemName && item.oemName.length > 0 && lowerCaseKeywords.some((keyword: any) => item.oemName.toLowerCase().includes(keyword))) ||
        (item.country && item.country.length > 0 && lowerCaseKeywords.some((keyword: any) => item.country.toLowerCase().includes(keyword))) ||
        (item.state && item.state.length > 0 && lowerCaseKeywords.some((keyword: any) => item.state.toLowerCase().includes(keyword))) ||
        (item.city && item.city.length > 0 && lowerCaseKeywords.some((keyword: any) => item.city.toLowerCase().includes(keyword)))
      );
    }

    if (countries && countries.length > 0) {
      filtered = filtered.filter(item =>
        item.country && countries.some((country: string) => item.country.toLowerCase() === country.toLowerCase())
      );
      this.loadStates(countries);
    }

    if (states && states.length > 0) {
      filtered = filtered.filter(item =>
        item.state && states.some((state: string) => item.state.toLowerCase() === state.toLowerCase())
      );
      this.loadCities(states);
    }

    if (cities && cities.length > 0) {
      filtered = filtered.filter(item =>
        item.city && cities.some((city: string) => item.city.toLowerCase() === city.toLowerCase())
      );
    }

    if (zipCode && zipCode.length > 0) {
      filtered = filtered.filter(item =>
        item.zipCode && String(item.zipCode) === String(zipCode));
    }

    if (brands && brands.length > 0) {
      filtered = filtered.filter(item =>
        (item.name && brands.some((name: string) => item.name.toLowerCase() === name.toLowerCase())) ||
        (item.oemName && brands.some((name: string) => item.oemName.toLowerCase() === name.toLowerCase()))
      );
    }

    this.filterSpecifications.forEach((spec: any) => {
      if (spec.specificationType === 'Text') {
        const selectedValues = this.filterForm.get(spec.specificationName)?.value;
        if (selectedValues && selectedValues.length > 0) {
          filtered = filtered.filter(item =>
            item.specifications.some((specification: any) => {
              if (specification.name === spec.specificationName && (specification.fromValue != null || specification.fromValue != undefined || specification.fromValue != "")
                && typeof specification.fromValue === 'string') {
                return specification.name === spec.specificationName &&
                  selectedValues.some((val: string) => specification.fromValue?.toLowerCase() === val.toLowerCase())
              } else if (specification.name === spec.specificationName && (specification.fromValue != null || specification.fromValue != undefined || specification.fromValue != "")
                && typeof specification.fromValue === 'number') {
                return specification.name === spec.specificationName &&
                  selectedValues.some((val: string) => specification.fromValue === val)
              }
            })
          );
        }
      }
    });

    this.filterSpecifications?.forEach((spec: any) => {
      if (spec?.specificationType === 'Number') {
        const fromValue = this.filterForm?.get(`${spec.specificationName}From`)?.value;
        const toValue = this.filterForm?.get(`${spec.specificationName}To`)?.value;
        if (fromValue != null && toValue != null) {
          filtered = filtered?.filter(item =>
            item.specifications?.some((specification: any) =>
              specification.name === spec.specificationName &&
              (specification.fromValue >= fromValue &&
                specification.fromValue <= toValue)
            )
          );
        } else if (fromValue != null) {
          filtered = filtered?.filter(item =>
            item.specifications?.some((specification: any) =>
              specification.name === spec.specificationName &&
              specification.fromValue >= fromValue
            )
          );
        }
      }
    });
    this.filteredData.emit(filtered);
  }
  getProductName(id: string): string {
    const product = this.dataObj.find(item => item.id === id);
    return product ? product.productName : 'Unknown Product'; // Return the name if found, otherwise a default value
  }
  isCategoryFilter(): boolean {
    if (this.brandProfileProducts === 'Catalogs') {
      return true;
    }
    return false;

  }
  loadProducts(brandId: string) {
    if (this.brandId) {
      this.allProductService.getAllProductsByOemId(brandId).subscribe({
        next: (response) => {
          this.products = response.data;
        },
        error: (error) => {
        }
      });
    }
  }

  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
        this.filteredCountries = allCountries;
      });
  }

  loadStates(countryName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allStates: any[] = [];
    let morePages = true;
    this.masterDataService.getStates(pageNumber, pageSize, '', [countryName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', [countryName]);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }

  loadCities(stateName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allCities: any[] = [];
    let morePages = true;
    this.masterDataService.getCities(pageNumber, pageSize, '', [stateName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', [stateName]);
        })
      )
      .subscribe(data => {
        allCities = allCities.concat(data.data);
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }

  loadBrands() {
    this.oemService.getBrandsList().subscribe({
      next: (response) => {
        this.brands = response.data;
        this.filteredBrands = response.data;
      },
      error: (error) => {
      }
    });
  }

  newProducts() {
    this.route.params.subscribe(params => {
      if (params !== undefined && params !== null && Object.entries(params).length > 0) {
        this.brandId = params?.['id']
      }
    });
    let pageNumber = 0;
    let pageSize = 10;
    this.productsService.getNewProducts(this.brandId, pageSize, pageNumber).subscribe({
      next: (response) => {
        this.dataObj2 = response.data;

        this.newProductss.emit(this.dataObj2);
      },
      error: (error) => {

      }
    });
  }

  loadSpecialities() {
    let pageNumber = 0;
    let pageSize = 100;
    let allSpecialities: any[] = [];
    let morePages = true;
    this.masterDataService.getSpecialities(pageNumber, pageSize, '')
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false; // No more items to fetch
            return [];
          }
          allSpecialities = allSpecialities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getSpecialities(pageNumber, pageSize, '');
        })
      )
      .subscribe(data => {
        allSpecialities = allSpecialities.concat(data.data);
        this.specialities = allSpecialities;
      });
  }

  resetFilters() {
    const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.filterForm.reset();
    this.productIdsList = [];
    this.productIdsListEmit.emit(this.productIdsList);
    this.applyFilter();
  }
  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  removeArrayItem(field: string, value: any): void {
    const currentArray = this.filterForm.get(field)?.value;
    if (Array.isArray(currentArray)) {
      const updatedArray = currentArray.filter((item: any) => item !== value);
      this.filterForm.get(field)?.setValue(updatedArray);
      this.applyFilter();

    }
  }


  add(controlName: string, event: any): void {
    const value = event?.value?.trim() || event?.name || (typeof controlName === 'string' ? controlName.trim() : '');
    if (value) {
      const currentValues = this.filterForm.get(controlName)?.value || [];
      if (!currentValues.includes(value)) {
        this.filterForm.get(controlName)?.setValue([...currentValues, value]);
      }
    }

    // Reset suggestions and input
    this.searchSuggestions = [];
    this.isSugestionOpen = false;

    const input = event?.input || document.querySelector('input[placeholder="Search By Keyword"]');
    if (input) {
      input.value = '';
    }
  }

  remove(controlName: string, item: string | number): void {
    const control = this.filterForm.get(controlName);

    if (control && typeof control.value !== 'number') {
      const currentValues = control.value || [];
      const index = currentValues.indexOf(item);
      if (index >= 0) {
        currentValues.splice(index, 1);
        control.setValue(currentValues);
      }
      if (this.isCatalogSection) {
        this.filteredCatalogInfo = this.filteredCatalogInfo.filter((data: any) => data?.productName.toLowerCase() !== item.toString().toLowerCase());
        this.productIdsList = this.filteredCatalogInfo.map((data: any) => data?.productInfoId);
        if (this.productIdsList && this.productIdsList.length > 0) {
          this.productIdsListEmit.emit(this.productIdsList);
        } else if (!this.productIdsList || this.productIdsList.length === 0) {
          this.productIdsListEmit.emit([]);
        }
      }

      this.applyFilter();
    } else if (control && typeof control.value === 'number') {
      const currentValues = control.value
      control.setValue(null);
    }
  }

  onOptionSelected(event: any, filterType: string): void {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'continent':
      case 'country':
        currentValues = this.filterForm.get('countries')?.value || [];
        if (!currentValues.includes(event.option.value.countryName)) {
          this.filterForm.get('countries')?.setValue([...currentValues, event.option.value.countryName]);
        }
        this.countryControl.reset();
        break;
      case 'state':
        currentValues = this.filterForm.get('states')?.value || [];
        if (!currentValues.includes(event.option.value.stateName)) {
          this.filterForm.get('states')?.setValue([...currentValues, event.option.value.stateName]);
        }
        this.stateControl.reset();
        break;
      case 'city':
        currentValues = this.filterForm.get('cities')?.value || [];
        if (!currentValues.includes(event.option.value.cityName)) {
          this.filterForm.get('cities')?.setValue([...currentValues, event.option.value.cityName]);
        }
        this.cityControl.reset();
        break;

      case 'brand':
        currentValues = this.filterForm.get('brands')?.value || [];
        if (!currentValues.includes(event.option.value.name)) {
          this.filterForm.get('brands')?.setValue([...currentValues, event.option.value.name]);
        }
        this.brandControl.reset();
        break;

      default:
        break;
    }
    this.applyFilter();
  }

  getFilterSpecificationsByType(brandId: string, filterType: string): void {
    this.specificationService.getSpecificationsByType(brandId, filterType).subscribe(
      (response: any) => {

        this.filterSpecifications = response;
        this.filterSpecifications?.forEach((spec: any) => {
          if (spec.specificationType === 'Text') {
            if (!this.filterControls.includes(spec.specificationName) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(spec.specificationName, new FormControl([]));
              this.filterControls.push(spec.specificationName);
            }
          } else if (spec.specificationType === 'Number') {
            if (!this.filterControls.includes(`${spec.specificationName}From`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}From`, new FormControl());
              this.filterControls.push(`${spec.specificationName}From`);
            }
            if (!this.filterControls.includes(`${spec.specificationName}To`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}To`, new FormControl());
              this.filterControls.push(`${spec.specificationName}To`);
            }
          }
          this.filterSpecifications = Array.from(
            new Map(
              this.filterSpecifications
                .filter(s => s.specificationName && s.specificationName.trim() !== "") // Remove empty or null values
                .map(s => [s.specificationName, s]) // Create key-value pairs to remove duplicates
            ).values() // Extract unique objects
          );

        });
      },
      (error) => {
      }
    );
  }
  searchSuggestions: any[] = [];
  isSugestionOpen = false;
  debounceTimer: any;

  searchSuggestionDebounce(event: any) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() =>
      this.searchSuggestion(event),
      450);
  }

  searchSuggestion(event: any): void {
    const query = event?.target?.value?.trim() || '';
    if (query) {
      if (this.brandProfileProducts != '') {
        this.oemService.searchOemSuggestions(this.brandId, query, this.brandProfileProducts).subscribe(
          (response: any) => {
            this.searchSuggestions = response.data || [];
            this.isSugestionOpen = this.searchSuggestions.length > 0;
          },
          (error) => {
            this.searchSuggestions = [];
            this.isSugestionOpen = false;
          }
        );
      } else {
        this.productsService.searchSuggestion(this.brandId, query).subscribe(
          (response: any) => {
            this.searchSuggestions = response.data || [];
            this.isSugestionOpen = this.searchSuggestions.length > 0;
          },
          (error) => {
            this.searchSuggestions = [];
            this.isSugestionOpen = false;
          }
        );
      }
    } else {
      this.searchSuggestions = [];
      this.isSugestionOpen = false;
    }
  }

  selectedSuggestion(suggestion: any): void {
    if (suggestion?.name) {
      const value = suggestion.type.toLowerCase().includes("catelog") ? suggestion.id : suggestion.name;
      this.add('keywords', { value });
      const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = '';
      }


      this.searchSuggestions = [];
      this.isSugestionOpen = false;
    }
  }
  
  toggleSuggestions() {
    this.isSugestionOpen = !this.isSugestionOpen;
  }

  searchCatalogRelatedProducts(event: any) {
    const searchKeyword = event.target?.value;
    if (searchKeyword === '' || searchKeyword === null || searchKeyword === undefined) {
      this.filteredProductCatalogData = this.catalogData;
    } else if (searchKeyword !== "") {
      this.filteredProductCatalogData = this.catalogData.filter(data => data?.productName?.toLowerCase().includes(searchKeyword.toLowerCase()));
    }
  }

  openDropDown() {
    this.isProductsDropDownOpen = true;
  }

  selectProductCheckBox(event: any, product: any) {
    if (this.filterForm?.get('catalogProducts')?.value === null) {
      this.filterForm.get('catalogProducts')?.setValue([]);
    }
    const catalogProductsControl = this.filterForm.get('catalogProducts');
    if (catalogProductsControl?.value && catalogProductsControl?.value.includes(product?.productName)) {
      const filterCatalogProducts = catalogProductsControl?.value.filter((productName: any) => productName.toLowerCase() !== product?.productName.toLowerCase())
      catalogProductsControl?.patchValue(filterCatalogProducts);
      this.productIdsList = this.productIdsList.filter(id => id !== product?.productInfoId);
      this.filteredCatalogInfo = this.filteredCatalogInfo.filter(data => data?.productInfoId !== product?.productInfoId);
      this.productIdsListEmit.emit(this.productIdsList);
    } else if (catalogProductsControl?.value && !catalogProductsControl?.value.includes(product?.productName)) {
      catalogProductsControl?.value.push(product?.productName);
      this.productIdsList.push(product?.productInfoId);
      this.filteredCatalogInfo.push({
        productInfoId: product?.productInfoId,
        productName: product?.productName
      })
      this.productIdsListEmit.emit(this.productIdsList);
    }
  }

  closeDropDown(event: any) {
    const targetElement = event.target as HTMLElement;
    const formFieldElement = document.querySelector('.products-info-field');
    if (formFieldElement && formFieldElement.contains(targetElement)) {
      return;
    }
    this.isProductsDropDownOpen = false;
  }
}